import { render, staticRenderFns } from "./IngredientConfiguration.vue?vue&type=template&id=1b59a01c&scoped=true"
import script from "./IngredientConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./IngredientConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IngredientConfiguration.vue?vue&type=style&index=0&id=1b59a01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59a01c",
  null
  
)

export default component.exports